import(/* webpackMode: "eager" */ "/home/ubuntu/download/692db9755a241000145a0247/aiva_medical_supply/src/app/not-found.tsx");
